import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import $ from "jquery";
import "../../layout/mapsjs-ui.css";
/* import 'https://js.api.here.com/v3/3.0/mapsjs-core.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-service.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-ui.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-mapevents.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-clustering.js';
 */

// <script type="text/javascript" src="https://js.api.here.com/v3/3.0/mapsjs-core.js"></script>
//         <script type="text/javascript" src="https://js.api.here.com/v3/3.0/mapsjs-service.js"></script>
//         <script type="text/javascript" src="https://js.api.here.com/v3/3.0/mapsjs-ui.js"></script>
//         <script type="text/javascript" src="https://js.api.here.com/v3/3.0/mapsjs-mapevents.js"></script>
//         <script type="text/javascript" src="https://js.api.here.com/v3/3.0/mapsjs-clustering.js"></script>

export class OMSGeoLocation extends React.Component {
  static propTypes = {
    onLocationSubmit: PropTypes.func,
    Address: PropTypes.string,
  };

  state = {
    LocationLat: null,
    LoacationLong: null,
  };

  componentDidMount() {
    window
      .$("#getLocationModel")
      .off("shown.bs.modal")
      .on(
        "shown.bs.modal",
        function () {
          if (this.map === undefined) {
            this.loadMap();
            setTimeout(
              function () {
                if (this.state.IsViewLocation) this.addDraggableMarker(this.state.LocationLat, this.state.LocationLong);
                else this.searchAddressLocation();
              }.bind(this),
              2000
            );
          } else {
            if (this.state.IsViewLocation) this.addDraggableMarker(this.state.LocationLat, this.state.LocationLong);
            else this.searchAddressLocation();
          }
        }.bind(this)
      );
    document.getElementById("Search").value = this.props.Address;
  }

  loadMap = () => {
    var mapContainer = document.getElementById("map");

    var APPLICATION_ID = "fF44c0Lf6GzCoeb27d64";
    var APPLICATION_CODE = "vrzOQWmJLkGyzTMK74n12w";

    //var APPLICATION_ID = '7oM7HUWgX8ouW2Ehe0m2';
    //var APPLICATION_CODE = 'T7OsnFL0cXetB-J-VbDhrQ';

    if (this.platform === undefined) {
      const H = window.H;
      var platform = new H.service.Platform({
        app_id: APPLICATION_ID,
        app_code: APPLICATION_CODE,
        useCIT: false, // true
        useHTTPS: true,
      });

      var defaultLayers = platform.createDefaultLayers();
      var geocoder = platform.getGeocodingService();
      //var group = new H.map.Group();
      /*group.addEventListener('tap', function (evt) {
              this.map.setCenter(evt.target.getPosition());
              this.openBubble(evt.target.getPosition(), evt.target.getData());
            }.bind(this), false); */

      var map = new H.Map(mapContainer, defaultLayers.normal.map, {
        center: { lat: 52.516, lng: 13.3779 },
        zoom: 3,
      });

      //map.addObject(group);
      var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
      // Create the default UI components
      var ui = H.ui.UI.createDefault(map, defaultLayers);

      this.platform = platform;
      this.geocoder = geocoder;
      this.ui = ui;
      this.map = map;
      //this.group = group;
      this.behavior = behavior;
    }
  };

  onLocationSubmitClick = (e) => {
    e.preventDefault();
    if (this.props.onLocationSubmit !== undefined) {
      this.props.onLocationSubmit(this.state.LocationLat, this.state.LocationLong);
      window.$("#getLocationModel").modal("hide");
    }
    return false;
  };

  onGeocodeClick = (e) => {
    document.getElementById("Search").value = this.props.Address.replace(/\n/g, ",");
    this.setState({ IsViewLocation: false }, function () {
      window.$("#getLocationModel").modal("show");
    });
  };

  funcViewLocationOnMap = (lat, long) => {
    this.setState({ IsViewLocation: true, LocationLat: lat, LocationLong: long }, function () {
      window.$("#getLocationModel").modal("show");
    });
  };

  onSearchLocationClick = (e) => {
    e.preventDefault();
    this.searchAddressLocation();
  };

  searchAddressLocation = () => {
    if (this.map === undefined) return;

    if (this.geocoder === undefined) return;

    this.geocoder.geocode({ searchtext: document.getElementById("Search").value }, this.onGeocodeSuccess, this.onGeocodeError);
  };

  onGeocodeSuccess = (result) => {
    if (result !== undefined && result.Response !== undefined && result.Response.View != undefined && result.Response.View != null) {
      if (result.Response.View.length > 0 && result.Response.View[0].Result !== undefined && result.Response.View[0].Result.length > 0) {
        var resultLocation = result.Response.View[0].Result[0];
        this.addDraggableMarker(resultLocation.Location.DisplayPosition.Latitude, resultLocation.Location.DisplayPosition.Longitude);
      }
    }
  };

  onGeocodeError = (error) => {
    alert(error);
  };

  addDraggableMarker = (lat, long) => {
    const H = window.H;
    if (this.marker === undefined) {
      var marker = new H.map.Marker({ lat: lat, lng: long });
      marker.draggable = true;
      this.map.addObject(marker);
      this.marker = marker;

      this.map.setZoom(15);
      this.map.setCenter({ lat: lat, lng: long });

      // disable the default draggability of the underlying map
      // when starting to drag a marker object:
      this.map.addEventListener(
        "dragstart",
        function (ev) {
          var target = ev.target;
          if (target instanceof H.map.Marker) {
            this.behavior.disable();
          }
        }.bind(this),
        false
      );

      this.map.addEventListener(
        "dragend",
        function (ev) {
          var target = ev.target;
          if (target instanceof H.map.Marker) {
            this.behavior.enable();
            var location = target.getPosition();
            this.map.setCenter(location);
            this.setState({
              LocationLat: location.lat.toFixed(5),
              LocationLong: location.lng.toFixed(5),
            });
          }
        }.bind(this),
        false
      );

      this.map.addEventListener(
        "drag",
        function (ev) {
          var target = ev.target,
            pointer = ev.currentPointer;
          if (target instanceof H.map.Marker) {
            target.setPosition(this.map.screenToGeo(pointer.viewportX, pointer.viewportY));
          }
        }.bind(this),
        false
      );
    } else {
      if (this.marker instanceof H.map.Marker) {
        var point = new H.geo.Point(lat, long);
        this.marker.setGeometry(point);
        this.map.setCenter({ lat: lat, lng: long });
      }
    }

    this.setState({ LocationLat: lat, LocationLong: long });
  };

  render() {
    return (
      <div className="form-group">
        <input type="button" className="btn btn-primary" value="geocode from address" onClick={this.onGeocodeClick} style={{ marginLeft: "10px" }} />
        <div className="modal fade" id="getLocationModel" tabIndex={-1} role="dialog" aria-labelledby="getLocationModelLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                  ×
                </button>
                <h4 className="modal-title" id="getLocationModelLabel">
                  Physical location
                </h4>
              </div>
              <div className="modal-body">
                <br />
                <div id="map" style={{ height: "350px" }}></div>
                <br />
              </div>
              <div className="modal-footer">
                {this.state.IsViewLocation ? null : (
                  <div className="col-md-12">
                    <div className="form-group pull-left" style={{ marginBottom: "10px" }}>
                      <span htmlFor="SearchAddress">Search address</span>
                      <input type="text" className="form-control" style={{ marginLeft: "10px" }} id="Search" name="Search" placeholder="Search Address" />
                      <button type="button" className="btn btn-primary" style={{ marginLeft: "10px" }} onClick={this.onSearchLocationClick}>
                        Search
                      </button>
                    </div>
                  </div>
                )}
                {this.state.IsViewLocation ? null : (
                  <div className="col-md-12">
                    <div className="form-group form-inline pull-left">
                      <span htmlFor="SearchAddress">
                        Marker position (lat,long):
                        <label>
                          {this.state.LocationLat},{this.state.LocationLong}
                        </label>
                      </span>
                    </div>
                  </div>
                )}
                <div className="col-md-12">
                  <button type="button" className="btn btn-default" data-dismiss="modal">
                    Close
                  </button>
                  {this.state.IsViewLocation ? null : (
                    <button type="button" className="btn btn-primary" onClick={this.onLocationSubmitClick}>
                      Use position
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class OMSGeoMap extends React.Component {
  static propTypes = {
    onGeoMapChange: PropTypes.func,
  };

  componentDidMount() {}

  loadMap = () => {
    const H = window.H;
    if (this.map === undefined) {
      var mapContainer = document.getElementById("map");

      var APPLICATION_ID = "fF44c0Lf6GzCoeb27d64";
      var APPLICATION_CODE = "vrzOQWmJLkGyzTMK74n12w";

      //var APPLICATION_ID = '7oM7HUWgX8ouW2Ehe0m2';
      //var APPLICATION_CODE = 'T7OsnFL0cXetB-J-VbDhrQ';

      if (this.platform === undefined) {
        var platform = new H.service.Platform({
          app_id: APPLICATION_ID,
          app_code: APPLICATION_CODE,
          useCIT: false,
          useHTTPS: true,
        });

        var defaultLayers = platform.createDefaultLayers();
        var geocoder = platform.getGeocodingService();
        //var group = new H.map.Group();
        /*group.addEventListener('tap', function (evt) {
                  this.map.setCenter(evt.target.getPosition());
                  this.openBubble(evt.target.getPosition(), evt.target.getData());
                }.bind(this), false); */

        var map = new H.Map(mapContainer, defaultLayers.normal.map, {
          center: { lat: 52.516, lng: 13.3779 },
          zoom: 3,
        });

        //map.addObject(group);
        var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
        // Create the default UI components
        var ui = H.ui.UI.createDefault(map, defaultLayers);

        this.platform = platform;
        this.geocoder = geocoder;
        this.ui = ui;
        this.map = map;
        //this.group = group;
        this.behavior = behavior;
      }
    }
  };

  onLocationChanged = (lat, long) => {
    this.addDraggableMarker(lat, long);
  };

  onSearchAddressLocation = (search) => {
    if (this.map === undefined) return;

    if (this.geocoder === undefined) return;

    this.geocoder.geocode({ searchtext: search }, this.onGeocodeSuccess, this.onGeocodeError);
  };

  onGeocodeSuccess = (result) => {
    if (result !== undefined && result.Response !== undefined && result.Response.View != undefined && result.Response.View != null) {
      if (result.Response.View.length > 0 && result.Response.View[0].Result !== undefined && result.Response.View[0].Result.length > 0) {
        var resultLocation = result.Response.View[0].Result[0];
        this.addDraggableMarker(resultLocation.Location.DisplayPosition.Latitude, resultLocation.Location.DisplayPosition.Longitude);
      }
    }
  };

  onGeocodeError = (error) => {
    alert(error);
  };

  addDraggableMarker = (lat, long) => {
    const H = window.H;
    if (this.map === undefined) return;

    if (this.marker === undefined) {
      var marker = new H.map.Marker({ lat: lat, lng: long });
      marker.draggable = true;
      this.map.addObject(marker);
      this.marker = marker;

      this.map.setZoom(15);
      this.map.setCenter({ lat: lat, lng: long });

      // disable the default draggability of the underlying map
      // when starting to drag a marker object:
      this.map.addEventListener(
        "dragstart",
        function (ev) {
          var target = ev.target;
          if (target instanceof H.map.Marker) {
            this.behavior.disable();
          }
        }.bind(this),
        false
      );

      this.map.addEventListener(
        "dragend",
        function (ev) {
          var target = ev.target;
          if (target instanceof H.map.Marker) {
            this.behavior.enable();
            var location = target.getPosition();
            this.map.setCenter(location);
            if (this.props.onGeoMapChange !== undefined) this.props.onGeoMapChange(location.lat, location.lng);
          }
        }.bind(this),
        false
      );

      this.map.addEventListener(
        "drag",
        function (ev) {
          var target = ev.target,
            pointer = ev.currentPointer;
          if (target instanceof H.map.Marker) {
            target.setPosition(this.map.screenToGeo(pointer.viewportX, pointer.viewportY));
          }
        }.bind(this),
        false
      );
    } else {
      if (this.marker instanceof H.map.Marker) {
        var point = new H.geo.Point(lat, long);
        this.marker.setGeometry(point);
        this.map.setCenter({ lat: lat, lng: long });
      }
    }

    if (this.props.onGeoMapChange !== undefined) this.props.onGeoMapChange(lat, long);
  };

  render() {
    return (
      <div>
        <br />
        <div id="map" style={{ height: "350px" }}></div>
        <br />
      </div>
    );
  }
}
